import { render, staticRenderFns } from "./specialVehicle.vue?vue&type=template&id=2604bb36&scoped=true"
import script from "./specialVehicle.vue?vue&type=script&lang=js"
export * from "./specialVehicle.vue?vue&type=script&lang=js"
import style0 from "./specialVehicle.vue?vue&type=style&index=0&id=2604bb36&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604bb36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2604bb36')) {
      api.createRecord('2604bb36', component.options)
    } else {
      api.reload('2604bb36', component.options)
    }
    module.hot.accept("./specialVehicle.vue?vue&type=template&id=2604bb36&scoped=true", function () {
      api.rerender('2604bb36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/specialVehicle/specialVehicle.vue"
export default component.exports